import { relationships } from "@rocicorp/zero";
import { crew } from "./crew";
import { organization } from "./organization";
import { plan } from "./plan";

export const organizationRelationships = relationships(organization, ({ many }) => ({
	crews: many({
		sourceField: ["id"],
		destField: ["orgId"],
		destSchema: crew,
	}),
	plans: many({
		sourceField: ["id"],
		destField: ["orgId"],
		destSchema: plan,
	}),
}));
